import Swal from "sweetalert2";

export  const alertError = (error) => {
    Swal.fire({
        icon: "error",
        title: "Failed to save to server",
        position: "top-end",
        text: error.message,
      });
}